import React from 'react'
import iphone from '@loyal_images/products/iphone.jpg'
const OrderProductItem = () => (
  <div className='cart-products col-12 mx-0'>
    <div className='cart-item row px-2 border-color-ui-3 border-bottom py-2'>
      <div className='cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'>
        <img src={iphone} alt='Imagem do produto' />
      </div>

      <div className='cart-product-info col'>
        <div className='cart-product-info row'>
          <div className='product-infos col-12 mx-0'>
            <h2 className='txt-body-sm txt-font-body color-ui-2 '>
              Smartphone Samsung Galaxy S7 dourado com 32GB, tela 5.1”, android
              6.0, 4G câmera 12MP
            </h2>
          </div>
        </div>
        <div className='row card-price-item  mt-1'>
          <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            Quantidade: <strong>2</strong>
          </div>
          <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            Valor unitário: <strong>2.000 reales</strong>
          </div>
          <div className='col-12 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
            Previsão de entrega: <strong>10/11/2018</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default OrderProductItem



// WEBPACK FOOTER //
// ./src/features/User/Orders/OrderProductItem.js